export default "__VITE_ASSET__Cw55HaOe__"